import { createTheme, alpha } from '@mui/material/styles';

// Trading-specific color palette (shared with lightTheme)
export const tradingColors = {
  bull: { main: '#00C853', light: '#4CAF50', dark: '#2E7D32' },
  bear: { main: '#FF1744', light: '#F44336', dark: '#C62828' },
  neutral: { main: '#FFB300', light: '#FFC107', dark: '#F57C00' },
  chart: { grid: '#2A2A2A', axis: '#404040', volume: alpha('#1976d2', 0.7) },
  trading: { buy: '#00C853', sell: '#FF1744', spread: '#9C27B0', profit: '#00E676', loss: '#FF5252' },
};

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#2196F3',
      light: '#64B5F6',
      dark: '#1976D2',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#9C27B0',
      light: '#CE93D8',
      dark: '#7B1FA2',
    },
    success: {
      main: '#00C853',
      light: '#4CAF50',
      dark: '#2E7D32',
    },
    error: {
      main: '#FF1744',
      light: '#F44336',
      dark: '#C62828',
    },
    warning: {
      main: '#FF9800',
      light: '#FFB74D',
      dark: '#F57C00',
    },
    background: {
      default: '#0F1923',
      paper: '#1A2332',
    },
    text: {
      primary: '#E0E0E0',
      secondary: '#9E9E9E',
    },
    divider: 'rgba(255, 255, 255, 0.08)',
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: 'none',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          transition: 'transform 0.2s ease-in-out, border-color 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px)',
            borderColor: 'rgba(255, 255, 255, 0.16)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none' as const,
          fontWeight: 600,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '1px solid rgba(255, 255, 255, 0.08)',
          backgroundColor: '#0F1923',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
});
